import { createMedium, createSidecarMedium } from '../../../use-sidecar/dist/es2015/medium.js';

var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true
});

export { mediumBlur, mediumEffect, mediumFocus, mediumSidecar };
